// fuel type constant
export const FUEL_TYPE_ELECTRIC_ID = 4;
export const FUEL_TYPE_HYBRID_ID = 5;
export const FUEL_TYPE_HYBRID_PETROL_ELECTRIC_ID = 8;
export const FUEL_TYPE_HYBRID_DIESEL_ELECTRIC_ID = 9;

// body type constant
export const BODY_TYPE_RACING_ID = 18;

// vehicle type constant
export const VEHICLE_TYPE_MINI_BUS_ID = 3;

// consumption type constant
export const CONSUMPTION_COMBINED_ID = 3;

// Unit type constant
export const POWER_UNIT_KW = 'kw';

// Accessory Plug in charge id constant
export const ACC_PLUGIN_CHARGE_ID = 53;

// Accessory Tow Bar id constant
export const ACC_TOW_BAR_ID = 4;

// Drive type four wheel id constant
export const DRIVE_TYPE_FOUR_WHEEL_ID = 3;
